import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter as Router } from "react-router-dom";
import { ReactQueryDevtools } from "react-query/devtools";
import React, { Suspense } from "react";

import { ChakraThemeProvider } from "ChakraTheme";
import { Spinner } from "components/Spinner";
import { ErrorBoundary } from "components/ErrorBoundary";

import { ContextConfigurationProvider } from "./ContextConfigurationProvider";

import { IChildrenProp } from "types/IChildrenProp";
import { QueryParamsProvider } from "./QueryParamsProvider";

interface IProps extends IChildrenProp {}

const Providers = ({ children }: IProps) => {
  const queryClient = new QueryClient();

  return (
    <Router>
      <ChakraThemeProvider>
        <ErrorBoundary>
          <QueryParamsProvider>
            <QueryClientProvider client={queryClient}>
              <Suspense
                fallback={<Spinner position="absolute" top="50%" left="50%" />}
              >
                <ContextConfigurationProvider>
                  {children}
                </ContextConfigurationProvider>
              </Suspense>
              <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
          </QueryParamsProvider>
        </ErrorBoundary>
      </ChakraThemeProvider>
    </Router>
  );
};

export { Providers };
